import React, { useEffect } from 'react'
import {
  PrivacyBanner as CentivoPrivacyBanner,
  palette,
  PrivacyBannerProps,
} from '@centivo/react-components'
import styled, { css } from 'styled-components'

const PrivacyBannerContainer = styled.div`
  & > div {
    background-color: ${palette.brand.darkGreen};
    color: ${palette.neutral.white};

    .banner--content {
      a {
        color: ${palette.brand.lightGreen};
      }

      a:hover {
        color: ${palette.brand.lightGreen};
      }

      a:focus {
        color: ${palette.brand.lightGreen};
        text-decoration: underline;
      }

      .banner--dismiss {
        color: ${palette.brand.lightGreen};
      }

      .banner--dismiss:hover {
        color: ${palette.brand.lightGreen};
      }

      .banner--dismiss:focus {
        color: ${palette.brand.lightGreen};
        text-decoration: underline;
      }

      .icon-centivo--x,
      .icon-centivo--x:hover {
        color: #f7f4e6;
      }
    }
  }

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
      case 'template-eligibility':
        return css`
          & > div {
            z-index: 1;

            padding: 1.5rem 2.5rem 2.25rem 2.5rem;

            .banner--content {
              font-size: 0.875rem;
              line-height: 1.26rem;
              font-weight: 500;

              p {
                margin: 0;
              }

              .banner--dismiss {
                font-size: 0.875rem;
                line-height: 1.26rem;
                font-weight: 500;
              }
            }
          }
        `

      default:
        return {}
    }
  }}
`

export const PrivacyBanner: React.FC<PrivacyBannerProps> = props => {
  const { isOpen } = props
  useEffect(() => {
    // NOTE: DOING THIS BECAUSE CentivoPrivacyBanner is A TEMPLATE ELEMENT COMING FROM OUTSIDE OF THIS APPLICATION
    const bannerContentDiv = document.querySelector('.banner--content')
    if (bannerContentDiv) {
      const dismissButton = bannerContentDiv.querySelector(
        'button:nth-child(3)'
      )
      if (dismissButton) {
        dismissButton.setAttribute(
          'aria-label',
          'Tap to close the banner without agreeing to the cookie policy.'
        )
        const svgElement = dismissButton.querySelector('svg')
        if (svgElement) {
          svgElement.setAttribute('role', 'none')
          svgElement.setAttribute('aria-hidden', 'true')
        }
      }
    }
  }, [])
  return isOpen ? (
    <PrivacyBannerContainer
      aria-hidden={!isOpen}
      role="alertdialog"
      aria-modal="true"
    >
      <CentivoPrivacyBanner {...props} />
    </PrivacyBannerContainer>
  ) : null
}
